/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

function EnhancedTextInputController ($timeout) {
	var self = this;

	var formatCharsDisplay = function () {
		var length = 0;
		if (self.modelProp && self.modelProp.length >= 0) {
			length = self.modelProp.length;
		}

		var output = '' + (self.maxChars - length);
		while (output.length < 4) {
			output = '0' + output;
		}

		self.charsRemaining = output;
	};

	self.$postLink = function () {
		$timeout(function () {
			formatCharsDisplay();
		});
	};

	self.onFocus = function () {
		self.inputFocused = true;
		formatCharsDisplay();
	};

	self.onBlur = function () {
		self.inputFocused = false;
	};

	self.onInputChange = function () {
		formatCharsDisplay();
	};
}

angular
.module('prism-ui.components')
.component('enhancedTextinput', {
	templateUrl: 'components/visual/enhancedTextInput/enhanced-textinput-template.html',
	controller: EnhancedTextInputController,
	bindings: {
		modelProp: '=',
		maxChars: '@',
		disableProp: '=',
		inputId: '@'
	}
});
